import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { TEXT_STYLES } from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';

import STYLES from './CountryFlag.module.scss';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';

type Props = {
  url: string;
  text: string;
};

const CountryFlag = ({ text, url }: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) => (
      <div className={STYLES.CountryFlag__countryFlag}>
        <img
          alt={text}
          height={13}
          src={url}
          className={STYLES.CountryFlag__countryFlagImg}
        />
        <BpkText
          tagName="p"
          textStyle={isMobile ? TEXT_STYLES.sm : TEXT_STYLES.base}
        >
          {text}
        </BpkText>
      </div>
    )}
  </BpkBreakpoint>
);

export default CountryFlag;
